var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_46",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("g", { attrs: { id: "Layer_46_copy_2" } }, [
        _c("path", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: {
            d: "m46.666,75.73c1.11.229,2.261.355,3.446.355,1.106,0,2.182-.112,3.223-.313v-29.107c-1.041-.2-2.117-.313-3.223-.313-1.185,0-2.336.126-3.446.355v29.021Z",
          },
        }),
        _c("rect", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: {
            x: "40.5",
            y: "29.689",
            width: "18.999",
            height: "4.988",
            rx: "1",
            ry: "1",
          },
        }),
        _c("path", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: {
            d: "m57.153,29.689v-8.37c0-.552-.448-1-1-1h-12.305c-.552,0-1,.448-1,1v8.37",
          },
        }),
        _c("path", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: {
            d: "m42.847,34.584v46.675c0,2.761,2.239,5,5,5h4.305c2.761,0,5-2.239,5-5v-46.675",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }